<template>
    <option value="US915">US915</option>
    <option value="AU915">AU915</option>
    <option value="EU868">EU868</option>
</template>
